<header class="position__relative header_container">
  <img class="hero_header_img" src="assets/img/consultant-team-2.webp">
  <div class="header_text scroll-animations container-fluid">
    <div class="header_text_container position__relative">
      <h1 class="header_title animated mb-3">NUESTROS SERVICIOS</h1>
    </div>
  </div>
</header>

<section id="servicios" class="position__relative">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12">
        <div class="header_nav scroll-animations row">
          @for (section of sections; track section) {
          <div class="nav_tabs col-6 col-sm-6 col-md" routerLink="{{ section.link }}"
            routerLinkActive="active-sect-item">
            <div class="icons_white">
              <img src="{{ section.icon }}" alt="icon" class="filter">
            </div>
            <h4>{{ section.title }}</h4>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>
<router-outlet></router-outlet>

<div class="container">
  <div class="row justify__content-center">
    <div class="col-6 mt-10">
      <button class="btn_help" routerLink="/contacto">¿Te ayudamos?</button>
    </div>
  </div>
</div>
<br>